import { render, staticRenderFns } from "./SmMaterialInputBase.vue?vue&type=template&id=7edf6c76&"
import script from "./SmMaterialInputBase.vue?vue&type=script&lang=ts&"
export * from "./SmMaterialInputBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports